module.exports = __webpack_public_path__ + "static/media/water_bill.563808b6.svg";